import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import Money from 'common/components/money';
import TopProgressBar from 'common/components/top_progress_bar';
import CostBreakdown from 'pap/components/common/cost_breakdown';
import BottomNavGuarantee from 'pap/containers/common/bottom_nav_guarantee';
import { getDetailedCost } from 'pap/utils';
import { Link } from 'react-router';

const PAPProgressBar = ({ currentSectionName, currentStep, currentSectionStepCount, is1to1, links }) => {
  /* format props accordingly before passing on to generic <TopProgressBar/> component */
  const briefStep = { title: 'Brief', icon: 'file-text-o', substepCount: currentSectionStepCount };
  const detailsStep = { title: 'Details', icon: 'list-ul', substepCount: currentSectionStepCount };
  const reviewStep = { title: 'Review', icon: 'check-square-o', substepCount: 0 };
  const paymentStep = { title: 'Payment', icon: 'credit-card', substepCount: 0 };

  const steps = (
    is1to1? [detailsStep, briefStep, reviewStep] : [briefStep, detailsStep, reviewStep, paymentStep]
  );

  const currentSection = steps.map(s => s.title.toLowerCase()).indexOf(currentSectionName);
  /* only allow linking to sections prior to current one  */
  steps.forEach((s, i) => s.link = i < currentSection? links[s.title.toLowerCase()] : undefined);

  return (
    <TopProgressBar steps={steps} currentStep={currentSection} currentSubstep={currentStep} />
  );
};


/**
 * A component that is used to render the prev/next button at the bottom of the PAP screen
 * along with a togglable cost breakdown table.
 *
 * The information about whether the cost table is visible or hidden is stored in the component
 * state to avoid polutting the application state.
 *
 * @author Chris Detmer
 * @author Kamil Grymuza
 */
var PAPFormBottomNav = React.createClass({
  /**
   * @memberof PAPFormBottomNav
   *
   * @prop {function} onNextStep - a function to call when the "next" button is clicked
   * @prop {function} onPrevStep - a function to call when the "previous" button is clicked
   * @prop {boolean} nextEnabled - a boolean denoting whether the "next" button will be enabled
   * @prop {boolean} prevEnabled - a boolean denoting whether the "previous" button will be enabled
  */
  propTypes: {
    onNextStep: React.PropTypes.func,
    onPrevStep: React.PropTypes.func,
    nextEnabled: React.PropTypes.bool,
    prevEnabled: React.PropTypes.bool,
  },

  getInitialState: function(){
    return {
      showCostTable: false
    }
  },

  toggleCostTable: function(event){
    event.preventDefault();

    this.setState({
      showCostTable: !this.state.showCostTable
    });
  },

  renderGuarantee: function() {
    const { showGuarantee, subCategorySlug } = this.props;

    if (!showGuarantee) {
      return null;
    }

    return <BottomNavGuarantee subCategorySlug={subCategorySlug} />;
  },

  render: function() {
    const {
      currentFeatures, currentAwards, formValues, awardValue1to1, currentTips, showGuarantee,
      nextLabel, packageName, billables, user, hidePrice, saveEnabled, onSave, saveLabel,
    } = this.props;
    const { showCostTable } = this.state;

    const classes = classNames('pap-controls', {
      'with-cost-breakdown': showCostTable,
      'hide-price': hidePrice,
      'hide-guarantee': !showGuarantee
    });

    const navBackLinkClass = classNames("back", "btn", "btn-text", "pap-directional-btn");
    const navNextLinkClass = classNames("next", "btn", "btn-primary", "pap-directional-btn");
    const navSaveLinkClass = classNames(
      "save", "btn", "btn-gray-outline", "pap-directional-btn", "hide-for-small-only"
    );

    const tableToggleIconClasses = classNames(
      "fa", {"fa-angle-up": !showCostTable, "fa-angle-down": showCostTable}
    );

    const detailedCost = getDetailedCost(
      currentFeatures, currentAwards, formValues, awardValue1to1, billables, user.profile_data,
      currentTips
    );

    return (
      <div className={classes}>
        <button
          disabled={!this.props.prevEnabled}
          className={navBackLinkClass}
          onClick={function(event){this.props.onPrevStep()}.bind(this)}
          >
          <i className="fa fa-angle-left"></i> <span className="button-label">Back</span>
        </button>

        { onSave &&
        <button disabled={!saveEnabled} className={navSaveLinkClass} onClick={onSave}>
          { saveLabel || "Save" }
        </button> }
        <button disabled={!this.props.nextEnabled} className={navNextLinkClass}
           onClick={this.props.onNextStep.bind(this)}>
          <i className="fa fa-arrow-circle-right show-for-small-only"></i> <span className="button-label">{nextLabel || "Next"}</span>
        </button>

        { this.renderGuarantee() }

        <div className="pap-cost-breakdown-toggle">
          <button className="btn btn-text" onClick={this.toggleCostTable}>
            <span className="pap-cost-label">Total Cost: </span>
              {detailedCost.total > 0? <Money value={detailedCost.total}/>:'$0.00'}
            <i className={tableToggleIconClasses}></i>
          </button>
        </div>
        <div className="pap-cost-breakdown">
          <div className="row">
            <div className="columns medium-8 medium-offset-4">
              <div className="pap-cost-breakdown-content">
                <CostBreakdown detailedCost={detailedCost} packageName={packageName}/>
                { this.renderGuarantee() }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
});

export { PAPFormBottomNav, PAPProgressBar };



// WEBPACK FOOTER //
// ./pap/components/common/navigation.jsx